<template>
  <v-container fluid grid-list-md>
    <!--reports-->
    <p-connection-duration ref="connectionDuration"></p-connection-duration>
    <p-company-user-duration ref="companyUserDuration"></p-company-user-duration>
    <!-- O componente PTaskFather agora é utilizado com Vuex ao invés de utilizar "ref" porque ocorria um problema ao tentar gerar um relatório de tarefas filtradas. Foi alterado a estrutura para a geração de relatórios de tarefas. -->
    <!--reports-->
    <!-- Dialog que mostra os filtros do relatório personalizado -->
    <v-dialog v-model="dialogFilter" persistent scrollable :width="$vuetify.breakpoint.smAndDown ? '' : '600'">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Preencha seu filtro</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container v-if="this.filterFields.length <= 0" fluid grid-list-xs>
            <h3>Esse relatório não possui filtros</h3>
          </v-container>
          <v-container fluid grid-list-xs>
            <v-form @keyup.native.esc="close" @keyup.native.enter="confirmReport(3)">
              <v-layout row justify-space-between wrap>
                <!--//os campos sao montados dinamicamente atravez dos types, que é um props-->
                <v-flex v-for="(field, index) in filterFields" :key="index" :class="field.class ? field.class : 'xs12'">
                  <!--//campo string-->
                  <v-text-field v-if="field.type === 'string'" :label="field.title" v-model="field.value"
                  hint="Separe por vírgula para filtrar mais de uma opção. Ex: nome1,nome2,nome3"></v-text-field>
                  <!--//campo select-->
                  <v-autocomplete v-else-if="field.type === 'select'" multiple :label="field.title" clearable :items="field.items" item-text="id_text" item-value="id" return-object @input="val => {inputSelect(val, field)}"></v-autocomplete>
                  <!--//campo checkbox-->
                  <v-checkbox v-else-if="field.type === 'checkbox'" v-model="field.value" :label="field.title"></v-checkbox>
                  <!--//campo datetime-->
                  <p-date-time v-else-if="field.type === 'datetime'" :label="field.title" v-model="field.value" :defaultHour="field.time ? field.time : '00:00'">
                  </p-date-time>
                  <!--//campo date-->
                  <p-date v-else-if="field.type === 'date'" :label="field.title" v-model="field.value">
                  </p-date>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-2" :loading="loading" @click="confirmReport(3)">Confirmar</v-btn>
          <v-btn color="primary darken-2" :loading="loading" @click="confirmReport(2)">Excel</v-btn>
          <v-btn :loading="loading" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Dialog que mostra quando o usuário clica para solicitar um relatório personalizado -->



    <v-dialog v-model="dialogRequestReport" persistent scrollable :width="$vuetify.breakpoint.smAndDown ? '' : '600'">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Solicitação de Relatório</span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="dialogRequestReport=false">
            <v-icon color="#444">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-xs>
            <h3>Entre em contato com nosso suporte ao lado direito, ou pelas opções abaixo, para solicitar um relatório personalizado!</h3>
            <br>
            <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span><br>
            <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- /---------- -->
    <v-layout wrap align-center justify-start>
      <v-flex xs12>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.' + this.entity + '.icon')}}</v-icon>Relatórios do Sistema</span>
      </v-flex>
      <v-flex xs12 lg10 xl7>
        <v-layout row wrap>
          <v-flex v-for="(report, index) in reports" :key="index" :class="$vuetify.breakpoint.smAndDown ? 'xs12' : 'sm6 lg4'" :disabled="!checkPermission(report.name, 'view')" class="pa-3">
            <v-card :color="(index % 2 === 0) ? 'white' : '#00acc1'" :class="(index % 2 === 0) ? 'black--text' : 'white--text'" min-height="300px">
              <!-- <v-img :src="report.src" height="200px"> -->
                <v-card-title primary-title>
                  <v-layout wrap justify-center align-center>
                    <v-flex xs12 class="text-xs-center">
                      <v-icon :color="(index % 2 === 0) ? 'black' : 'white'" x-large>{{report.icon}}</v-icon>
                    </v-flex>
                    <v-flex xs12>
                      <p class="headline text-xs-center" style="height: 60px !important">{{report.title}}</p>
                      <p style="height: 70px !important">{{report.description}}</p>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              <!-- </v-img> -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip top :disabled="checkPermission(report.name, 'view')">
                  <v-btn slot="activator" :disabled="!checkPermission(report.name, 'view')" @click="reportClick(report.name)">Gerar relatório</v-btn>
                  <span>É necessário acesso para gerar esse relatório</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>


      <v-flex xs12>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.' + this.entity + '.icon')}}</v-icon>Relatórios Personalizados</span>
        <v-btn :loading="loadingReports" @click="requestReport()" style="margin-top: 0px;">Solicitar Relatório Personalizado</v-btn>
      </v-flex>
      <v-flex  xs12 lg10 xl7>
        <v-layout row wrap>
          <v-flex v-for="(report, index) in itemsCustomReports" :key="report.id" :class="$vuetify.breakpoint.smAndDown ? 'xs12' : 'sm6 lg4'" class="pa-3">
            <v-card :color="(index % 2 === 0) ? 'white' : '#00acc1'" :class="(index % 2 === 0) ? 'black--text' : 'white--text'" min-height="300px">
                <v-card-title primary-title>
                  <v-layout wrap justify-center align-center>
                    <v-flex xs12 class="text-xs-center">
                      <v-icon :color="(index % 2 === 0) ? 'black' : 'white'" x-large>library_books</v-icon>
                    </v-flex>
                    <v-flex xs12>
                      <p class="headline text-xs-center" style="height: 60px !important">{{report.id_text}}</p>
                      <p style="height: 70px !important">{{report.description}}</p>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              <!-- </v-img> -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip top :disabled="checkPermission('custom_reports', 'view')">
                  <v-btn slot="activator" :disabled="!checkPermission('custom_reports', 'view')" height="50px" @click="customReportClick(report)">Gerar relatório</v-btn>
                  <span>É necessário acesso para gerar relatórios personalizados</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>



    <v-dialog v-model="activeCustomReport" persistent :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
      <v-card>
        <v-card-title primary-title style="padding: 0 !important;">
          <v-layout wrap align-center justify-space-between>
            <v-flex xs6>
              <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.' + this.entity + '.icon')}}</v-icon>{{ this.isSelectedReport ? this.reportTitle : 'Consulta de Relatórios' }}</span>
            </v-flex>
            <!-- <v-flex xs4 v-if="!$vuetify.breakpoint.smAndDown">
              <v-select
                outline
                :disabled="loadingReports"
                :loading="loadingReports"
                :items="itemsCustomReports"
                placeholder="Selecione um Relatório"
                label="Relatórios"
                @change="selectReport"
                v-model="selectedReport"
                item-value="id"
                item-text="id_text"
                return-object
              ></v-select>
            </v-flex> -->
            <v-flex xs5>
              <v-layout row justify-start wrap>
                <v-flex xs6>
                  <v-text-field v-show="items.length > 0" :loading="loading" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
                </v-flex>
                <v-flex shirck>
                  <v-btn :disabled="items.length === 0" :loading="loading" color="primary" @click="confirmReport(1)" style="margin-top: 12px;">
                    PDF
                  </v-btn>
                  <v-btn :disabled="items.length === 0" :loading="loading" color="primary" @click="confirmReport(2)" style="margin-top: 12px;">
                    Excel
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1>
              <v-layout row justify-end>
                <v-btn icon class="text-xs-right" slot="activator" fab @click="closeCustomReport()">
                  <v-icon color="#444">close</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <!--//os campos sao montados dinamicamente atravez dos types, que é um props-->
            <v-layout row justify-end v-if="isSelectedReport && (filterFields.length > 0)">
              <v-flex xs12>
              <v-tooltip bottom>
                <v-btn small slot="activator" outline fab color="orange" @click="editFilter()">
                  <v-icon medium>edit</v-icon>
                </v-btn>
                <span>Editar filtro</span>
              </v-tooltip>
                <span v-for="(field, index) in filterFields" :key="index"><strong>{{field['title']}}: </strong>{{field['value'] ? formatValue((field['type'] == 'select' ? field['value_text'] : field['value']), field['type']) : "' '"}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 90% !important">
          <v-layout wrap align-center justify-start>
            
            <v-flex xs12>
              <v-data-table
                hide-actions
                :no-data-text="dataText"
                rows-per-page-text="Registros por página"
                :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
                :headers="headers"
                :items="items"
                :search="search"
                :pagination.sync="customReportPagination"
                class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td v-for="(header, index) in headers" :key="index">
                    <div v-html="props.item[header.value]"></div>
                  </td>
                </template>
                <template v-slot:no-data>
                  Esse filtro não possui registros
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout row justify-center>
            <div class="v-datatable__actions__range-controls">
              <v-btn small :disabled="this.customReportPagination.page === 1" outline fab icon @click="previousPage()">
                <v-icon large>chevron_left</v-icon>
              </v-btn>
              <div class="v-datatable__actions__pagination">{{((this.customReportPagination.page - 1) * this.customReportPagination.rowsPerPage) + 1}} - {{(this.customReportPagination.page*this.customReportPagination.rowsPerPage) > this.customReportPagination.totalItems ? this.customReportPagination.totalItems : this.customReportPagination.page*this.customReportPagination.rowsPerPage}} de {{this.customReportPagination.totalItems}}</div>
              <v-btn :disabled="(this.customReportPagination.page*this.customReportPagination.rowsPerPage) >= this.customReportPagination.totalItems" small outline fab icon @click="nextPage()">
                <v-icon large>chevron_right</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import PDate from './shared/PDate'
  import PDateTime from './shared/PDateTime'
  import moment from 'moment'
  import access from '../mixin/access'
  import plan from '../mixin/plan'
  import PConnectionDuration from './reports/PConnectionDuration'
  import PCompanyUserDuration from './reports/PCompanyUserDuration'

  export default {
    mixins: [access, plan],
    components: {PDateTime, PDate, PConnectionDuration, PCompanyUserDuration},
    data: () => ({
      itemsCustomReports: [],
      loadingReports: false,
      activeCustomReport: false,
      dialogRequestReport: false,
      entity: 'reports',
      items: [],
      headers: [],
      customReportPagination: { 'descending': false, 'page': 1, 'rowsPerPage': 25, 'sortBy': null, 'totalItems': 0 },
      filterFields: [],
      defaultFilterFields: [],
      selectedReport: {},
      isSelectedReport: false,
      dialogFilter: false,
      reportId: 0,
      dataText: 'Nenhum relatório selecionado',
      reportTitle: '',
      search: '',
      reports: [],
      loading: false
    }),
    created () {
      this.reports = [
        {
          icon: this.translate('table.connections.icon'),
          title: 'Relatório de Duração Parcerias',
          name: 'report_connection',
          description: 'Esse relatório mostra a lista de durações agrupadas por parcerias.'
          // active: true,
        },
        {
          icon: this.translate('table.company_user.icon'),
          title: 'Relatório de Duração Participantes',
          name: 'report_participant',
          description: 'Esse relatório mostra a lista de durações agrupadas por participantes da sua empresa.'
          // active: true,
        }
      ]
      this.loadingReports = true
      this.$http.get(`api/${this.entity}`).then((res) => {
        this.itemsCustomReports = res.body
        this.loadingReports = false
      }, err => {
        console.log(err)
        this.loadingReports = false
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os relatórios personalizados, favor reportar o erro.', color: 'error', dialog: true})
      })
    },
    methods: {
      selectReport (report = this.selectedReport) {
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.get(`api/get_filters_report/${report.id}`).then(res => {
          report['fields'] = JSON.stringify(res.body)
          this.selectedReport = report
          this.reportId = report.id
          this.reportTitle = report.id_text
          // id será um numero em sequencia para que os filterFields nunca sejam repetidos, o title é o titulo que mostra pro usuário e o type o tipo do campo
          // [{"id": ,"title": ,"type":, "field":, "op":, "value":}]
          this.filterFields = this.defaultFilterFields.length > 0 ? this.defaultFilterFields : (report.fields ? (JSON.parse(report.fields)) : [])
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.dialogFilter = true
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Ocorreu um erro na busca do relatório, reporte o erro.', color: 'error', dialog: true})
        })
      },
      confirmReport (type = 3) {
        // passa os fields coms os valores para o back, no sql tera |field|id|field| que será substituido pelo field de acordo com o id dele
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.put(`api/generate_report/${this.reportId}`, {fields: this.filterFields, type: type}).then((res) => {
          this.defaultFilterFields = this.filterFields
          if (type === 3) {
            this.activeCustomReport = true
            this.items = res.body
            this.customReportPagination = { 'descending': false, 'page': 1, 'rowsPerPage': 25, 'sortBy': null, 'totalItems': this.items.length }
            if (this.items.length > 0) {
              this.dataText = 'Nenhum relatório selecionado'
              let headers = Object.keys(this.items[0])
              this.headers = []
              headers.forEach((header) => {
                this.headers.push({ text: header, value: header })
              })
            } else {
              this.dataText = 'Nenhum item encontrado para esse relatório'
            }
          } else {
            let fileName = res.bodyText
            window.open(process.env.API + 'uploads/reports/' + fileName, '_blank')
            let _this = this
            setTimeout(function () {
              _this.$http.delete(`api/delete_upload_report/${fileName}`)
            }, 5000)
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
          }
          this.dialogFilter = false
          this.isSelectedReport = true
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }, err => {
          console.log(err)
          this.dialogFilter = false
          this.filterFields = this.defaultFilterFields
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível abrir o relatório, favor reportar o erro.', color: 'error', dialog: true})
        })
      },
      openTaskReportDialog: function (taskId = null, idtext = null) {
        this.$store.commit('reportDialog/change_values', {
          showDialog: true,
          reportDialogLoading: true,
          reportDialogTasks: [{id: taskId, id_text: idtext}],
          reportDialogEditedItem: {task_id: taskId, id_text: idtext, begin: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 00:00'), end: !this.checkIsFree() ? '' : moment().format('YYYY-MM-DD 23:59')},
          reportDialogDisable: true,
          selectedTask: false
        })
        if (taskId !== null && taskId !== '') {
          this.$store.commit('reportDialog/change_values', { reportDialogLoading: false, selectedTask: true })
        } else {
          this.$http.get(`api/tasksReport`).then(res => {
            this.$store.commit('reportDialog/change_values', {
              reportDialogTasks: res.body,
              reportDialogLoading: false,
              reportDialogDisable: false
            })
          }, err => {
            console.log(err)
            this.$store.commit('snackbar/change_values', {text: 'Ocorreu um erro na busca do relatório, reporte o erro.', color: 'error', dialog: true})
          })
        }
      },
      inputSelect (val, field) {
        // o value começa com '' pois considera o vazio quando não possui nenhum registro
        field['value'] = ''
        field['value_text'] = ''
        if (val) {
          // recebe array vazio para receber o push embaixo
          field['value'] = []
          val.forEach(el => {
            field['value'].push(el['id'])
            field['value_text'] += el['id_text'] + ', '
          })
        }
      },
      close () {
        this.dialogFilter = false
        this.filterFields = this.defaultFilterFields
      },
      closeCustomReport () {
        this.activeCustomReport = false
        this.filterFields = []
        this.defaultFilterFields = []
      },
      formatValue (val, type) {
        if (val && val !== '') {
          if (type === 'date') {
            return moment(val).format('DD/MM/YYYY')
          } else if (type === 'datetime') {
            return moment(val).format('DD/MM/YYYY HH:mm')
          } else {
            return val
          }
        } else {
          return ''
        }
      },
      requestReport () {
        document.getElementById('purechat-btn').click()
        this.dialogRequestReport = true
      },
      reportClick (name) {
        switch (name) {
          case 'report_connection':
            this.$refs.connectionDuration.openDialog()
            break
          case 'report_participant':
            this.$refs.companyUserDuration.openDialog()
            break
          case 'report_task':
            this.openTaskReportDialog()
            break
        }
      },
      editFilter () {
        this.selectReport()
      },
      customReportClick (report) {
        this.selectReport(report)
        console.log('click report custom')
      },
      previousPage () {
        this.customReportPagination.page = this.customReportPagination.page - 1
      },
      nextPage (report) {
        this.customReportPagination.page = this.customReportPagination.page + 1
      }
    },
    destroyed () {
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Report.vue